"use strict";
function noop() {
}
module.exports = noop;
//# sourceMappingURL=noop.js.map